module.exports = __webpack_public_path__ + "public/files/img/register.55fa75a2.png";